/**
 * This list is comprised of known acronyms for topics that are on production
 * and are above or around 1M signatures. While this isn't the most efficient
 * way to handle acronyms, it handles more commons ones and creates more
 * consistency/accuracy than we had before.
 */
export const acronymDictionary = [
	'aapi',
	'nyc',
	'bts',
	'nypd',
	'lgbt',
	'lgbtq',
	'lgbti',
	'usda',
	'fda',
	'anwr',
	'ea',
	'ice',
	'icj',
	'dhs',
	'ups',
	'usps',
	'covid',
	'covid-19',
	'nba',
	'wnba',
	'nfl',
	'nfc',
	'hbo',
	'epa',
	'ftc',
	'als',
	'nbc',
	'ptsd',
	'un',
	'nasa',
	'nra',
];
